


export function getEinheitenForEnergietraeger(id: string) {
    switch (id)  {
        case 'erdgas':
            return ['kWh', 'm³'];
        case 'fluessiggas':
            return ['kWh', 'kg', 'Liter'];
        case 'hel':
            return ['kWh', 'Liter'];
        case 'bio_brennholz':
            return ['kWh', 'Rm', 'Rm (Raummeter)'];
        case 'bio_hackschnitzel':
            return ['kWh', 'Srm', 'Srm (Schüttraummeter)'];
        case 'bio_holzpellets':
            return ['kWh', 'kg'];
        case 'steinkohle':
            return ['kWh', 'kg'];
        case 'braunkohle':
            return ['kWh', 'kg'];
        case 'biogas':
            return ['kWh', 'kg', 'm³'];
        case 'biodiesel':
            return ['kWh', 'l'];
        case 'bioethanol':
            return ['kWh', 'l'];
        case 'diesel':
            return ['kWh', 'l'];
        case 'fernwaerme':
            return ['kWh', 'MWh'];
    }
    return ['kWh'];
}
